import React, { useEffect, useState } from 'react'
import {
    Box,
    Chip,
    Grid,
    IconButton,
    Tooltip,
    Typography
} from "@mui/material";
import TableContainer from '../../../Components/TableContainer/TableContainer';
import { useDispatch } from 'react-redux';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { ADD_UPDATE_NOTIFICATION_UNREAD_ACTION, GET_NOTIFICATION_LANGUAGE_REQUEST_ACTION } from '../../../Redux/Slices/NotificationSlice/NotificationSlice.action';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CustomInterpreterTabs from '../../../Components/CustomInterpreterTabPanel/CustomInterpreterTabs';
import CustomInterpreterTabPanel from '../../../Components/CustomInterpreterTabPanel/CustomInterpreterTabPanel';
import { GET_HOURLY_RATE_REQUEST_ACTION, POST_HOURLY_RATE_REQUEST_ACTION } from '../../../Redux/Slices/LanguageSlice/LanguageSlice.action';
import Swal from 'sweetalert2';
const NewLanguageRequest = () => {
    const pageSize = 15;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [newNotification, setNewNotification] = useState([]);
    const [newHourlyRateRequest, setNewHourlyRateRequest] = useState([]);
    const [languageActiveTabs, setLanguageActiveTabs] = useState(0);
    const languageTabs = [
        { label: 'New Language Request', content: 'New Language Request' },
        { label: 'Hourly Rate Request ', content: 'Hourly Rate Request' },
    ];
    const columns = [
        {

            field: "rowid",
            headerName: "Sr.No.",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "interpreter_name",
            headerName: "User Name",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const userName = params?.row?.interpreter_name || "--";
                return (
                    <Tooltip title={userName?.length > 25 ? userName : ""}>
                        <span>
                            {userName?.length > 25
                                ? `${userName?.substring(0, 25)}...`
                                : userName}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "language",
            headerName: "language",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const language = params?.row?.language || "--";
                return (
                    <Tooltip title={language?.length > 25 ? language : ""}>
                        <span>
                            {language?.length > 25
                                ? `${language?.substring(0, 25)}...`
                                : language}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "title",
            headerName: "Title",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const title = params?.row?.title || "--";
                return (
                    <Tooltip title={title?.length > 25 ? title : ""}>
                        <span>
                            {title?.length > 25
                                ? `${title?.substring(0, 25)}...`
                                : title}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "message",
            headerName: "Message",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const message = params?.row?.message || "--";
                return (
                    <Tooltip title={message?.length > 25 ? message : ""}>
                        <span>
                            {message?.length > 25
                                ? `${message?.substring(0, 25)}...`
                                : message}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "created_at",
            headerName: "Date",
            flex: 1,
            minWidth: 300,
            hideOnMobile: true,
            renderCell: (params) => (
                <Tooltip title={params?.row?.created_at || "--"}>
                    <span>{moment(params?.row?.created_at).format("MMM DD YYYY HH:MM A") || "--"}</span>
                </Tooltip>
            ),
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 150,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => {
                const { is_read } = params?.row;
                return <Chip label={is_read === 1 ? "Approved" : "Pending"} size="small" variant="outlined" sx={{
                    border: is_read === 1 ? "1px solid #16BC00CC" : "1px solid #FFCE80",
                    height: '36px',
                    borderRadius: '10px',
                    width: '117px',
                    fontFamily: "Outfit",
                    background: is_read === 1 ? "#16BC00CC" : "#FFCE80"
                }} />;
            },
        },
        {
            field: "action",
            headerName: "Actions",
            minWidth: 140,
            filterable: false,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                const { is_read, send_by, id } = params?.row;
                const actionButtons = [];
                actionButtons.push(
                    <Tooltip title="View" key="view">
                        <IconButton
                            onClick={() => {
                                handleNewLanguageApproveRejectRead(is_read, send_by, id);
                            }}
                            sx={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "4px",
                                background:
                                    "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                "&:hover": {
                                    background:
                                        "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                },
                            }}
                        >
                            <RemoveRedEyeIcon sx={{ color: "#fff" }} />
                        </IconButton>
                    </Tooltip>)
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                    >
                        {actionButtons}
                    </Box>
                );
            },
        },
    ];
    const columns1 = [
        {

            field: "rowid",
            headerName: "Sr.No.",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "full_name",
            headerName: "User Name",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const userName = params?.row?.full_name || "--";
                return (
                    <Tooltip title={userName?.length > 25 ? userName : ""}>
                        <span>
                            {userName?.length > 25
                                ? `${userName?.substring(0, 25)}...`
                                : userName}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "language",
            headerName: "language",
            minWidth: 250,
            filterable: true,
            sortable: true,
            flex: 1,
            renderCell: (params) => {
                const language = params?.row?.language || "--";
                return (
                    <Tooltip title={language?.length > 25 ? language : ""}>
                        <span>
                            {language?.length > 25
                                ? `${language?.substring(0, 25)}...`
                                : language}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "current_hourly_rate",
            headerName: "Current Hourly Rate",
            minWidth: 150,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const current_hourly_rate = `$${params?.row?.current_hourly_rate}` || "--";
                return (
                    <Tooltip title={current_hourly_rate?.length > 25 ? current_hourly_rate : ""}>
                        <span>
                            {current_hourly_rate?.length > 25
                                ? `${current_hourly_rate?.substring(0, 25)}...`
                                : current_hourly_rate}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "new_hourly_rate",
            headerName: "New Hourly Rate",
            minWidth: 150,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const new_hourly_rate = `$${params?.row?.new_hourly_rate}` || "--";
                return (
                    <Tooltip title={new_hourly_rate?.length > 25 ? new_hourly_rate : ""}>
                        <span>
                            {new_hourly_rate?.length > 25
                                ? `${new_hourly_rate?.substring(0, 25)}...`
                                : new_hourly_rate}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "created_at",
            headerName: "Date",
            minWidth: 200,
            hideOnMobile: true,
            renderCell: (params) => (
                <Tooltip title={params?.row?.created_at || "--"}>
                    <span>{moment(params?.row?.created_at).format("MMM DD YYYY HH:MM A") || "--"}</span>
                </Tooltip>
            ),
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 150,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => {
                const { status } = params?.row;
                return <Chip label={status === 1 ? "Approved" : "Pending"} size="small" variant="outlined" sx={{
                    border: status === 1 ? "1px solid #16BC00CC" : "1px solid #FFCE80",
                    height: '36px',
                    borderRadius: '10px',
                    width: '117px',
                    fontFamily: "Outfit",
                    background: status === 1 ? "#16BC00CC" : "#FFCE80"
                }} />;
            },
        },
        {
            field: "action",
            headerName: "Actions",
            minWidth: 140,
            filterable: false,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                const { is_read, send_by, id } = params?.row;
                const actionButtons = [];
                
                actionButtons.push(
                    <>
                        <Tooltip title="Approve Request">
                            <IconButton
                                sx={{
                                    background: "#4caf50",
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "4px",
                                    "&:hover": { background: "#388e3c" },
                                }}
                                onClick={() => handleHourlyRateLanguage(id, 1, params)}
                            >
                                <CheckIcon sx={{ color: "#fff" }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Reject Request">
                            <IconButton
                                sx={{
                                    background: "red",
                                    "&:hover": { background: "#c62828" },
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "4px",
                                }}
                                onClick={() => handleHourlyRateLanguage(id, -1)}
                            >
                                <CloseIcon sx={{ color: "#fff" }} />
                            </IconButton>
                        </Tooltip></>
                )
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                    >
                        {actionButtons}
                    </Box>
                );
            },
        },
    ];
    useEffect(() => {
        return () => {
            setNewNotification([])
            setNewHourlyRateRequest([])
        }
    }, []);
    useEffect(() => {
        if (languageActiveTabs === 0) {
            getNotification();
        }
    }, [page, languageActiveTabs === 0]);

    useEffect(() => {
        if (languageActiveTabs === 1) {
            getHourlyRateRequest();
        }
    }, [page, languageActiveTabs === 1]);
    const getNotification = async () => {
        setIsLoading(true)
        try {
            await dispatch(GET_NOTIFICATION_LANGUAGE_REQUEST_ACTION()).unwrap()
                .then((res) => {
                    if (res && res?.s === 1) {
                        const Rowdata = res?.r?.map((data, i) => ({
                            rowid: i + 1 + page * pageSize,
                            ...data,
                        }));

                        setNewNotification(Rowdata);
                        page === 0 && setCount(res?.total || 0);
                        setIsLoading(false)
                    } else {
                        setNewNotification([]);
                        setIsLoading(false)
                    }
                })
        } catch (error) {
            console.log('error', error);
            setIsLoading(false)
        }
    }
    
    const getHourlyRateRequest = async () => {
        setIsLoading(true)
        try {
            await dispatch(GET_HOURLY_RATE_REQUEST_ACTION()).unwrap()
                .then((res) => {
                    if (res && res?.s === 1) {
                        const Rowdata = res?.r?.map((data, i) => ({
                            rowid: i + 1 + page * pageSize,
                            ...data,
                        }));

                        setNewHourlyRateRequest(Rowdata);
                        page === 0 && setCount(res?.total || 0);
                        setIsLoading(false)
                    } else {
                        setNewHourlyRateRequest([]);
                        setIsLoading(false)
                    }
                })
        } catch (error) {
            console.log('error', error);
            setIsLoading(false)
        }
    }
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };
    const handleNewLanguageApproveRejectRead = async (is_read, send_by, id) => {
        if (is_read === 1) {
            navigate(`/admin/interpreter-details`, {
                state: { id: send_by },
            });
        } else {
            try {
                const res = await dispatch(ADD_UPDATE_NOTIFICATION_UNREAD_ACTION(id)).unwrap()
                if (res && res?.s === 1) {
                    navigate(`/admin/interpreter-details`, {
                        state: { id: send_by },
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        }

    }
    const handleOnChangeActiveTabsLanguage = (event, newValue) => {
        setLanguageActiveTabs(newValue);
        setPage(0);
    };
   const handleHourlyRateLanguage = async (id, status) => {
           Swal.fire({
               title: 'Are you sure?',
               text: status === 1 ? 'Do you want to accept this request?' : "Do you want to reject this request",
               icon: 'warning',
               showCancelButton: true,
               confirmButtonText: 'Yes',
               cancelButtonText: 'No',
               reverseButtons: true,
           }).then(async (result) => {
               if (result.isConfirmed) {
                   try {
                       const res = await dispatch(POST_HOURLY_RATE_REQUEST_ACTION({ id, status })).unwrap()
                       if (res && res?.s === 1) {
                           getHourlyRateRequest();
                           Swal.fire({
                               position: "center",
                               icon: "success",
                               title: status === 1 ? "Approved!" : "Rejected!",
                               showConfirmButton: false,
                               timer: 1500,
                           });
                       } else {
                           Swal.fire({
                               icon: "error",
                               title: "Oops...",
                               text: "There was an error processing your request. Please try again later.",
                           });
                       }
                   } catch (error) {
                       console.error("Error updating status:", error);
                       Swal.fire({
                           icon: "error",
                           title: "Oops...",
                           text: "Something went wrong. Please try again later.",
                       });
                   }
               }
           });
       }
    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    bgcolor: "#fff",
                    padding: '10px'
                }}
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                            }}
                        >
                            <IconButton
                                onClick={() => navigate(-1)}
                                sx={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "4px",
                                    background: "rgba(0, 151, 178, 1)",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    outline: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    ":hover": {
                                        background: "rgba(0, 151, 178, 1)",
                                    },
                                }}
                            >
                                <KeyboardArrowLeftIcon
                                    sx={{
                                        fontSize: "32px",
                                        color: "#fff",
                                    }}
                                />
                            </IconButton>
                            <Typography
                                variant="h6"
                                sx={{
                                    color: "#000",
                                    fontSize: { xs: '18px', md: "22px" },
                                    fontWeight: "500",
                                    fontFamily: "Outfit",
                                    paddingLeft: '10px'
                                }}
                            >
                                Manage Requests
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        width: "100%",
                        paddingTop: "24px",
                    }}
                >
                    <CustomInterpreterTabs
                        tabValue={languageActiveTabs}
                        onChange={handleOnChangeActiveTabsLanguage}
                        interpreterTabs={languageTabs}
                    />
                    <CustomInterpreterTabPanel value={languageActiveTabs} index={0}>
                        <Box sx={{
                            paddingTop: '10px',
                            boxSizing: 'border-box'
                        }}>
                            <TableContainer
                                rows={newNotification}
                                columns={columns}
                                loading={isLoading}
                                sx={{
                                    height: "calc(100vh - 205px)"
                                }}
                                pageSize={pageSize}
                                page={page}
                                totalCount={count}
                                handlePageChange={handlePageChange}
                                isPagination={true}
                            />
                        </Box>
                    </CustomInterpreterTabPanel>
                    <CustomInterpreterTabPanel value={languageActiveTabs} index={1}>
                        <Box sx={{
                            paddingTop: '10px',
                            boxSizing: 'border-box'
                        }}>
                            <TableContainer
                                rows={newHourlyRateRequest}
                                columns={columns1}
                                loading={isLoading}
                                sx={{
                                    height: "calc(100vh - 205px)"
                                }}
                                pageSize={pageSize}
                                page={page}
                                totalCount={count}
                                handlePageChange={handlePageChange}
                                isPagination={true}
                            />
                        </Box>
                    </CustomInterpreterTabPanel>
                </Box>
            </Box>
        </>
    )
}

export default NewLanguageRequest